// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab-module_tab_2XYb6","disabled":"Tab-module_disabled_1pAaH","selected":"Tab-module_selected_2-tSf","dropdown":"Tab-module_dropdown_3aLdo"};